import React, { useState, useEffect } from "react";
import { Form, Input, Select, Radio, DatePicker, Button, Upload, InputNumber } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { DataProvider } from "../../DataProvider";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import { notificationMessage, notificationTitle, openNotificationType } from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";

const DeliveryDetails = ({ formRef, disabled, initialValues }) => {

    const dataProvider = new DataProvider()
    const [disableAreaOccupied, setDisableAreaOccupied] = useState(false);
    const [mstUnloadingArea, setMstUnloadingArea] = useState([]);
    const [position, setPosition] = useState(initialValues && initialValues['live_location']?initialValues['live_location']: "");

    const masterDataMapping = {
        "MstUnloadingArea": setMstUnloadingArea,
    };

    const fetchDropdownValues = () => {
        Object.keys(masterDataMapping).forEach((model, index) => {
            dataProvider.getDropdownValues(model)
                .then((response) => {
                    if (response.ok) {
                        response.json().then((data) => {
                            const setter = masterDataMapping[model];
                            setter(data.results)
                        })
                    } else {
                        response.json().then((responseJson) => {
                            openNotification("error", "Error", responseJson["message"]);
                        });
                    }
                }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
        })
    }

    const fetchLocation = () => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setPosition(`${position.coords.latitude} | ${position.coords.longitude}`);
                openNotification(
                    openNotificationType.info,
                    notificationTitle.form,
                    "Location fetched successfully!"
                )
                formRef.current.setFieldValue('live_location', `${position.coords.latitude} | ${position.coords.longitude}`)
            });
        } else {
            alert("Geolocation is not available in your browser.");
        }
    }

    useEffect(() => {
        fetchDropdownValues();
    }, []);

    return (
        <>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="vehicle_no" label="Vehicle Number">
                    <Input
                        placeholder="Enter Vehicle Number"
                        disabled={disabled} />
                </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12">
                <Form.Item required name="received_date" label="Received Date">
                    <DatePicker
                        style={{ width: "100%" }}
                        disabled={disabled} />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="area_unloaded" label="Area Unloaded">
                    <Select
                        allowClear
                        showSearch
                        placeholder="Select Area Unloaded"
                        disabled={disabled}
                        optionFilterProp="label"
                        options={mstUnloadingArea.map((val) => ({
                            value: val.id,
                            label: val.unloading_area,
                        }))} />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="area_occupied" label="Area Occupied">
                    <InputNumber
                        placeholder="Enter Area Occupied"
                        disabled={disableAreaOccupied}
                        style={{width: '100%'}} />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="area_grid" label="Area/Grid">
                    <Input
                        placeholder="Enter Area/Grid"
                        disabled={disabled} />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="stacked" label="Stacked">
                    <Radio.Group onChange={(e) =>{
                        if(e.target.value){
                                formRef.current.setFieldsValue({area_occupied : 0})
                                setDisableAreaOccupied(true)
                            } else {   
                            formRef.current.setFieldsValue({area_occupied : initialValues["area_required"]})
                            setDisableAreaOccupied(false) }
                    }}>
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                    </Radio.Group>
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="live_location" label="Live Location">
                    <Button onClick={fetchLocation}>Click to Fetch</Button>
                </Form.Item>
                {position && <p>Fetched Approx. Location - {position}</p>}
            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name="photograph"
                    valuePropName="fileList"
                    label="Photograph"
                    rules={[{ required: true, message: "Please upload photograph" }]}
                    extra={"Max. 1 file (.jpg/.jpeg) | Upto 15 MB."}
                    getValueFromEvent={(e) => e.fileList}
                >

                    <Upload name="logo"
                        listType="picture"
                        disabled={disabled}
                        beforeUpload={(file, fileList) => {
                            let ext = file.name.split(".").at(-1);
                            if (!["jpg", "jpeg"].includes(ext)) {
                                openNotification(
                                    openNotificationType.error,
                                    notificationTitle.form,
                                    notificationMessage.fileTypeNotAllowed
                                );
                                return Upload.LIST_IGNORE;
                            }
                            let kb = file.size / 1000;
                            let mb = kb / 1000;
                            if (mb > 16) {
                                openNotification(
                                    openNotificationType.error,
                                    notificationTitle.form,
                                    notificationMessage.fileSizeExceeded
                                );
                                return Upload.LIST_IGNORE;
                            }
                            return false;
                        }}
                        onChange={({ file, fileList, event }) => {
                            if (fileList.length > 1) {
                                openNotification(
                                    openNotificationType.error,
                                    notificationTitle.form,
                                    notificationMessage.fileLimitExceeded
                                );
                                fileList.pop();
                            }
                        }}
                    >
                        <Button disabled={disabled} icon={<UploadOutlined />}>
                            Click to upload
                        </Button>
                    </Upload>
                </Form.Item>
            </div>
            
        </>
    )
}

export default DeliveryDetails;